export const TRANSACTION_CLASSES = Object.freeze({
  TRANSFER: "TRANSFER",
  RETURN: "RETURN",
});